import { createBrowserRouter } from "react-router-dom";
import SignupPage from "./pages/signup";
import LoginPage from "./pages/login";
import HomePage from "./pages/home";
import ActivitiesPage from "./pages/activities";
import SingleActivityPage from "./pages/single-activity";
import ThirtyDayChallengePage from "./pages/thirty-day-challenge";
import ForgotPasswordPage from "./pages/forgot-password";
import ResetPasswordPage from "./pages/reset-password";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PublicRoute from "./components/auth/PublicRoute";
import CalendarPage from "./pages/Calendar";
import ProfilePage from "./pages/profile";
import PrivacyPolicy from "./pages/privacy-policy";
import LandingPage from "./pages/landing";
import NotificationsPage from "./pages/notifications";
import MindMapsPage from "./pages/mindmaps";
import MindMapEditorPage from "./pages/mindmap-editor";
const Router = createBrowserRouter([
    {
        path: "/",
        element: <LandingPage />
    },
    {
        path: "/login",
        element: (
            <PublicRoute>
                <LoginPage />
            </PublicRoute>
        )
    },
    {
        path: "/signup",
        element: (
            <PublicRoute>
                <SignupPage />
            </PublicRoute>
        )
    },
    {
        path: "/forgot-password",
        element: (
            <PublicRoute>
                <ForgotPasswordPage />
            </PublicRoute>
        )
    },
    {
        path: "/reset-password",
        element: (
            <PublicRoute>
                <ResetPasswordPage />
            </PublicRoute>
        )
    },
    {
        path: "/home",
        element: (
            <ProtectedRoute>
                <HomePage />
            </ProtectedRoute>
        )
    },
    {
        path: "/activities",
        element: (
            <ProtectedRoute>
                <ActivitiesPage />
            </ProtectedRoute>
        )
    },
    {
        path: "/activity/:activityId/view",
        element: (
            <ProtectedRoute>
                <SingleActivityPage />
            </ProtectedRoute>
        )
    },
    {
        path: "/activity/:activityId/30-day-challenge/:challengeId",
        element: (
            <ProtectedRoute>
                <ThirtyDayChallengePage />
            </ProtectedRoute>
        )
    },
    {
        path: "/calendar",
        element: (
            <ProtectedRoute>
                <CalendarPage />
            </ProtectedRoute>
        )
    },
    {
        path: "/profile",
        element: (
            <ProtectedRoute>
                <ProfilePage />
            </ProtectedRoute>
        )
    },
    {
        path: "/mindmaps",
        element: (
            <ProtectedRoute>
                <MindMapsPage />
            </ProtectedRoute>
        )
    },
    {
        path: "/mindmaps/:mindMapId",
        element: (
            <ProtectedRoute>
                <MindMapEditorPage />
            </ProtectedRoute>
        )
    },
    {
        path: "/privacy-policy",
        element: <PrivacyPolicy />
    },
    {
        path: "/notifications",
        element: (
            <ProtectedRoute>
                <NotificationsPage />
            </ProtectedRoute>
        )
    }
]);

export default Router;